import { msteams } from '../../api/msteams';
import { BrowserFourdApi } from '.';

export class MsTeams implements msteams.Api {
  constructor(private fourd: BrowserFourdApi) {}

  shareDocument(request: msteams.ShareDocumentRequest): void {
    this.fourd.call4Dv2('msteams.shareDocument', request);
  }

  shareMatter(request: msteams.ShareMatterRequest): void {
    this.fourd.call4Dv2('msteams.shareMatter', request);
  }

  requestCallback(request: msteams.RequestCallbackRequest): void {
    this.fourd.call4Dv2('msteams.requestCallback', request);
  }
}
